module.exports = __webpack_public_path__ + "media/images/logo-meet-squared-40ce7b1e73d6030cf5e8946c8729fd94.svg";